export const configEnvironment = {
  production: true,
  API: '/api',
  keycloak: {
    url: 'https://kullanici-safirdepo.b3lab.org',
    realm: 'SafirDepo',
    clientId: 'angular-client',
  },

  onlyOffice: {
    url: 'https://ofis-safirdepo.b3lab.org',
  },
  apiUrl: 'https://safirdepo.b3lab.org',
  sgeUrl: 'https://guvenlidepolama.b3lab.org',
  hasRtukUrl: false,
};
